// hooks/useTrackVideo.ts
import { QueryClient, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getTrackVideo, trackVideoEvent, TrackVideoPayload } from "../api/trackLMSApi";

const trackDB = process.env.REACT_APP_DATABASE;

export const useTrackVideo = () => {
  return useMutation({
    mutationFn: (payload: TrackVideoPayload) => trackVideoEvent(payload),
  });
};

export const useTrackList = (id: any, moodleUser: any) => {
  return useQuery({
    queryKey: ["track-video", id],
    queryFn: () =>
      getTrackVideo({
        token: sessionStorage.getItem("wstoken"),
        privatetoken: sessionStorage.getItem("privatetoken"),
        limit: 100,
        userid: moodleUser?.id,
        page: 1,
        course: id,
        database: trackDB,
      }),
    enabled: !!id,
    select: (res) => res?.result || [], // 👈 lấy thẳng mảng video
  });
};

export const useTracById = (id: any, moodleUser: any) => {
  return useQuery({
    queryKey: ["track-video", id],
    queryFn: () =>
      getTrackVideo({
        token: sessionStorage.getItem("wstoken"),
        privatetoken: sessionStorage.getItem("privatetoken"),
        limit: 1000,
        userid: moodleUser?.id,
        page: 1,
        course: id,
        database: trackDB,
      }),
    enabled: !!id,
    select: (res) => res?.result || [], // 👈 lấy thẳng mảng video
  });
};